import { j as It } from "./jsx-runtime-B6kdoens.js";
import { createContext as Kn, Fragment as En, useState as Nn, useRef as Ln, useEffect as Bn } from "react";
const _n = typeof window < "u", Wn = Kn({ strict: !1 }), be = (t) => t.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase(), $n = "framerAppearId", Gn = "data-" + be($n), Un = {
  skipAnimations: !1,
  useManualTiming: !1
};
function jn(t) {
  let e = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set(), s = !1, r = !1;
  const i = /* @__PURE__ */ new WeakSet();
  let o = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  };
  function u(l) {
    i.has(l) && (a.schedule(l), t()), l(o);
  }
  const a = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (l, c = !1, h = !1) => {
      const f = h && s ? e : n;
      return c && i.add(l), f.has(l) || f.add(l), l;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (l) => {
      n.delete(l), i.delete(l);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (l) => {
      if (o = l, s) {
        r = !0;
        return;
      }
      s = !0, [e, n] = [n, e], n.clear(), e.forEach(u), s = !1, r && (r = !1, a.process(l));
    }
  };
  return a;
}
const ue = [
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
], zn = 40;
function Hn(t, e) {
  let n = !1, s = !0;
  const r = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, i = () => n = !0, o = ue.reduce((g, y) => (g[y] = jn(i), g), {}), { read: u, resolveKeyframes: a, update: l, preRender: c, render: h, postRender: d } = o, f = () => {
    const g = performance.now();
    n = !1, r.delta = s ? 1e3 / 60 : Math.max(Math.min(g - r.timestamp, zn), 1), r.timestamp = g, r.isProcessing = !0, u.process(r), a.process(r), l.process(r), c.process(r), h.process(r), d.process(r), r.isProcessing = !1, n && e && (s = !1, t(f));
  }, m = () => {
    n = !0, s = !0, r.isProcessing || t(f);
  };
  return { schedule: ue.reduce((g, y) => {
    const v = o[y];
    return g[y] = (x, w = !1, S = !1) => (n || m(), v.schedule(x, w, S)), g;
  }, {}), cancel: (g) => {
    for (let y = 0; y < ue.length; y++)
      o[ue[y]].cancel(g);
  }, state: r, steps: o };
}
function $e(t) {
  return typeof t == "string" || Array.isArray(t);
}
function Ge(t) {
  return t !== null && typeof t == "object" && typeof t.start == "function";
}
const Ue = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], je = ["initial", ...Ue];
function kt(t) {
  return Ge(t.animate) || je.some((e) => $e(t[e]));
}
function qn(t) {
  return !!(kt(t) || t.variants);
}
const it = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, ne = {};
for (const t in it)
  ne[t] = {
    isEnabled: (e) => it[t].some((n) => !!e[n])
  };
function ot(t) {
  for (const e in t)
    ne[e] = {
      ...ne[e],
      ...t[e]
    };
}
const O = (t) => t;
let re = O, H = O;
process.env.NODE_ENV !== "production" && (re = (t, e) => {
  !t && typeof console < "u" && console.warn(e);
}, H = (t, e) => {
  if (!t)
    throw new Error(e);
});
const Yn = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function Xn(t) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof t != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    t.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(Yn.indexOf(t) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/u.test(t))
    )
  );
}
const Zn = {}, ie = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], L = new Set(ie);
function Jn(t, { layout: e, layoutId: n }) {
  return L.has(t) || t.startsWith("origin") || (e || n !== void 0) && (!!Zn[t] || t === "opacity");
}
const R = (t) => !!(t && t.getVelocity), Qn = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, es = ie.length;
function ts(t, e, n) {
  let s = "";
  for (let r = 0; r < es; r++) {
    const i = ie[r];
    if (t[i] !== void 0) {
      const o = Qn[i] || i;
      s += `${o}(${t[i]}) `;
    }
  }
  return s = s.trim(), n ? s = n(t, e ? "" : s) : e && (s = "none"), s;
}
const Kt = (t) => (e) => typeof e == "string" && e.startsWith(t), Et = Kt("--"), ns = Kt("var(--"), ze = (t) => ns(t) ? ss.test(t.split("/*")[0].trim()) : !1, ss = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu, rs = (t, e) => e && typeof t == "number" ? e.transform(t) : t, q = (t, e, n) => n > e ? e : n < t ? t : n, X = {
  test: (t) => typeof t == "number",
  parse: parseFloat,
  transform: (t) => t
}, ee = {
  ...X,
  transform: (t) => q(0, 1, t)
}, ce = {
  ...X,
  default: 1
}, te = (t) => Math.round(t * 1e5) / 1e5, He = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu, is = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu, os = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu;
function oe(t) {
  return typeof t == "string";
}
function as(t) {
  return t == null;
}
const ae = (t) => ({
  test: (e) => oe(e) && e.endsWith(t) && e.split(" ").length === 1,
  parse: parseFloat,
  transform: (e) => `${e}${t}`
}), k = ae("deg"), j = ae("%"), p = ae("px"), ls = ae("vh"), us = ae("vw"), at = {
  ...j,
  parse: (t) => j.parse(t) / 100,
  transform: (t) => j.transform(t * 100)
}, lt = {
  ...X,
  transform: Math.round
}, Nt = {
  // Border props
  borderWidth: p,
  borderTopWidth: p,
  borderRightWidth: p,
  borderBottomWidth: p,
  borderLeftWidth: p,
  borderRadius: p,
  radius: p,
  borderTopLeftRadius: p,
  borderTopRightRadius: p,
  borderBottomRightRadius: p,
  borderBottomLeftRadius: p,
  // Positioning props
  width: p,
  maxWidth: p,
  height: p,
  maxHeight: p,
  size: p,
  top: p,
  right: p,
  bottom: p,
  left: p,
  // Spacing props
  padding: p,
  paddingTop: p,
  paddingRight: p,
  paddingBottom: p,
  paddingLeft: p,
  margin: p,
  marginTop: p,
  marginRight: p,
  marginBottom: p,
  marginLeft: p,
  // Transform props
  rotate: k,
  rotateX: k,
  rotateY: k,
  rotateZ: k,
  scale: ce,
  scaleX: ce,
  scaleY: ce,
  scaleZ: ce,
  skew: k,
  skewX: k,
  skewY: k,
  distance: p,
  translateX: p,
  translateY: p,
  translateZ: p,
  x: p,
  y: p,
  z: p,
  perspective: p,
  transformPerspective: p,
  opacity: ee,
  originX: at,
  originY: at,
  originZ: p,
  // Misc
  zIndex: lt,
  backgroundPositionX: p,
  backgroundPositionY: p,
  // SVG
  fillOpacity: ee,
  strokeOpacity: ee,
  numOctaves: lt
};
function Lt(t, e, n) {
  const { style: s, vars: r, transform: i, transformOrigin: o } = t;
  let u = !1, a = !1, l = !0;
  for (const c in e) {
    const h = e[c];
    if (Et(c)) {
      r[c] = h;
      continue;
    }
    const d = Nt[c], f = rs(h, d);
    if (L.has(c)) {
      if (u = !0, i[c] = f, !l)
        continue;
      h !== (d.default || 0) && (l = !1);
    } else c.startsWith("origin") ? (a = !0, o[c] = f) : s[c] = f;
  }
  if (e.transform || (u || n ? s.transform = ts(t.transform, l, n) : s.transform && (s.transform = "none")), a) {
    const { originX: c = "50%", originY: h = "50%", originZ: d = 0 } = o;
    s.transformOrigin = `${c} ${h} ${d}`;
  }
}
function ut(t, e, n) {
  return typeof t == "string" ? t : p.transform(e + n * t);
}
function cs(t, e, n) {
  const s = ut(e, t.x, t.width), r = ut(n, t.y, t.height);
  return `${s} ${r}`;
}
const hs = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, ds = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function fs(t, e, n = 1, s = 0, r = !0) {
  t.pathLength = 1;
  const i = r ? hs : ds;
  t[i.offset] = p.transform(-s);
  const o = p.transform(e), u = p.transform(n);
  t[i.array] = `${o} ${u}`;
}
function ps(t, {
  attrX: e,
  attrY: n,
  attrScale: s,
  originX: r,
  originY: i,
  pathLength: o,
  pathSpacing: u = 1,
  pathOffset: a = 0,
  // This is object creation, which we try to avoid per-frame.
  ...l
}, c, h) {
  if (Lt(t, l, h), c) {
    t.style.viewBox && (t.attrs.viewBox = t.style.viewBox);
    return;
  }
  t.attrs = t.style, t.style = {};
  const { attrs: d, style: f, dimensions: m } = t;
  d.transform && (m && (f.transform = d.transform), delete d.transform), m && (r !== void 0 || i !== void 0 || f.transform) && (f.transformOrigin = cs(m, r !== void 0 ? r : 0.5, i !== void 0 ? i : 0.5)), e !== void 0 && (d.x = e), n !== void 0 && (d.y = n), s !== void 0 && (d.scale = s), o !== void 0 && fs(d, o, u, a, !1);
}
const ms = (t) => typeof t == "string" && t.toLowerCase() === "svg";
function Bt(t, { style: e, vars: n }, s, r) {
  Object.assign(t.style, e, r && r.getProjectionStyles(s));
  for (const i in n)
    t.style.setProperty(i, n[i]);
}
const _t = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function gs(t, e, n, s) {
  Bt(t, e, void 0, s);
  for (const r in e.attrs)
    t.setAttribute(_t.has(r) ? r : be(r), e.attrs[r]);
}
function Wt(t, e, n) {
  var s;
  const { style: r } = t, i = {};
  for (const o in r)
    (R(r[o]) || e.style && R(e.style[o]) || Jn(o, t) || ((s = n == null ? void 0 : n.getValue(o)) === null || s === void 0 ? void 0 : s.liveStyle) !== void 0) && (i[o] = r[o]);
  return n && r && typeof r.willChange == "string" && (n.applyWillChange = !1), i;
}
function ys(t, e, n) {
  const s = Wt(t, e, n);
  for (const r in t)
    if (R(t[r]) || R(e[r])) {
      const i = ie.indexOf(r) !== -1 ? "attr" + r.charAt(0).toUpperCase() + r.substring(1) : r;
      s[i] = t[r];
    }
  return s;
}
function ct(t) {
  const e = [{}, {}];
  return t == null || t.values.forEach((n, s) => {
    e[0][s] = n.get(), e[1][s] = n.getVelocity();
  }), e;
}
function $t(t, e, n, s) {
  if (typeof e == "function") {
    const [r, i] = ct(s);
    e = e(n !== void 0 ? n : t.custom, r, i);
  }
  if (typeof e == "string" && (e = t.variants && t.variants[e]), typeof e == "function") {
    const [r, i] = ct(s);
    e = e(n !== void 0 ? n : t.custom, r, i);
  }
  return e;
}
const De = (t) => Array.isArray(t), Yi = (t) => !!(t && typeof t == "object" && t.mix && t.toValue), vs = (t) => De(t) ? t[t.length - 1] || 0 : t, Gt = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform"
  // TODO: Can be accelerated but currently disabled until https://issues.chromium.org/issues/41491098 is resolved
  // or until we implement support for linear() easing.
  // "background-color"
]);
function bs(t) {
  if (L.has(t))
    return "transform";
  if (Gt.has(t))
    return be(t);
}
function Ts(t, e) {
  t.indexOf(e) === -1 && t.push(e);
}
function Ut(t, e) {
  const n = t.indexOf(e);
  n > -1 && t.splice(n, 1);
}
const { schedule: P, cancel: fe, state: pe, steps: Xi } = Hn(typeof requestAnimationFrame < "u" ? requestAnimationFrame : O, !0);
function _(t, e, n, s = { passive: !0 }) {
  return t.addEventListener(e, n, s), () => t.removeEventListener(e, n);
}
const Vs = (t) => t.pointerType === "mouse" ? typeof t.button != "number" || t.button <= 0 : t.isPrimary !== !1;
function jt(t, e = "page") {
  return {
    point: {
      x: t[`${e}X`],
      y: t[`${e}Y`]
    }
  };
}
const ws = (t) => (e) => Vs(e) && t(e, jt(e));
function he(t, e, n, s) {
  return _(t, e, ws(n), s);
}
const xs = (t, e) => (n) => e(t(n)), K = (...t) => t.reduce(xs);
function zt(t) {
  let e = null;
  return () => {
    const n = () => {
      e = null;
    };
    return e === null ? (e = t, n) : !1;
  };
}
const Ss = zt("dragHorizontal"), As = zt("dragVertical");
function Ps(t) {
  let e = !1;
  {
    const n = Ss(), s = As();
    n && s ? e = () => {
      n(), s();
    } : (n && n(), s && s());
  }
  return e;
}
function Ht() {
  const t = Ps();
  return t ? (t(), !1) : !0;
}
class Z {
  constructor(e) {
    this.isMounted = !1, this.node = e;
  }
  update() {
  }
}
function ht(t, e) {
  const n = e ? "pointerenter" : "pointerleave", s = e ? "onHoverStart" : "onHoverEnd", r = (i, o) => {
    if (i.pointerType === "touch" || Ht())
      return;
    const u = t.getProps();
    t.animationState && u.whileHover && t.animationState.setActive("whileHover", e);
    const a = u[s];
    a && P.postRender(() => a(i, o));
  };
  return he(t.current, n, r, {
    passive: !t.getProps()[s]
  });
}
class Cs extends Z {
  mount() {
    this.unmount = K(ht(this.node, !0), ht(this.node, !1));
  }
  unmount() {
  }
}
class Ms extends Z {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let e = !1;
    try {
      e = this.node.current.matches(":focus-visible");
    } catch {
      e = !0;
    }
    !e || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = K(_(this.node.current, "focus", () => this.onFocus()), _(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
const qt = (t, e) => e ? t === e ? !0 : qt(t, e.parentElement) : !1;
function Ae(t, e) {
  if (!e)
    return;
  const n = new PointerEvent("pointer" + t);
  e(n, jt(n));
}
class Fs extends Z {
  constructor() {
    super(...arguments), this.removeStartListeners = O, this.removeEndListeners = O, this.removeAccessibleListeners = O, this.startPointerPress = (e, n) => {
      if (this.isPressing)
        return;
      this.removeEndListeners();
      const s = this.node.getProps(), i = he(window, "pointerup", (u, a) => {
        if (!this.checkPressEnd())
          return;
        const { onTap: l, onTapCancel: c, globalTapTarget: h } = this.node.getProps(), d = !h && !qt(this.node.current, u.target) ? c : l;
        d && P.update(() => d(u, a));
      }, {
        passive: !(s.onTap || s.onPointerUp)
      }), o = he(window, "pointercancel", (u, a) => this.cancelPress(u, a), {
        passive: !(s.onTapCancel || s.onPointerCancel)
      });
      this.removeEndListeners = K(i, o), this.startPress(e, n);
    }, this.startAccessiblePress = () => {
      const e = (i) => {
        if (i.key !== "Enter" || this.isPressing)
          return;
        const o = (u) => {
          u.key !== "Enter" || !this.checkPressEnd() || Ae("up", (a, l) => {
            const { onTap: c } = this.node.getProps();
            c && P.postRender(() => c(a, l));
          });
        };
        this.removeEndListeners(), this.removeEndListeners = _(this.node.current, "keyup", o), Ae("down", (u, a) => {
          this.startPress(u, a);
        });
      }, n = _(this.node.current, "keydown", e), s = () => {
        this.isPressing && Ae("cancel", (i, o) => this.cancelPress(i, o));
      }, r = _(this.node.current, "blur", s);
      this.removeAccessibleListeners = K(n, r);
    };
  }
  startPress(e, n) {
    this.isPressing = !0;
    const { onTapStart: s, whileTap: r } = this.node.getProps();
    r && this.node.animationState && this.node.animationState.setActive("whileTap", !0), s && P.postRender(() => s(e, n));
  }
  checkPressEnd() {
    return this.removeEndListeners(), this.isPressing = !1, this.node.getProps().whileTap && this.node.animationState && this.node.animationState.setActive("whileTap", !1), !Ht();
  }
  cancelPress(e, n) {
    if (!this.checkPressEnd())
      return;
    const { onTapCancel: s } = this.node.getProps();
    s && P.postRender(() => s(e, n));
  }
  mount() {
    const e = this.node.getProps(), n = he(e.globalTapTarget ? window : this.node.current, "pointerdown", this.startPointerPress, {
      passive: !(e.onTapStart || e.onPointerStart)
    }), s = _(this.node.current, "focus", this.startAccessiblePress);
    this.removeStartListeners = K(n, s);
  }
  unmount() {
    this.removeStartListeners(), this.removeEndListeners(), this.removeAccessibleListeners();
  }
}
const Ie = /* @__PURE__ */ new WeakMap(), Pe = /* @__PURE__ */ new WeakMap(), Rs = (t) => {
  const e = Ie.get(t.target);
  e && e(t);
}, Os = (t) => {
  t.forEach(Rs);
};
function Ds({ root: t, ...e }) {
  const n = t || document;
  Pe.has(n) || Pe.set(n, {});
  const s = Pe.get(n), r = JSON.stringify(e);
  return s[r] || (s[r] = new IntersectionObserver(Os, { root: t, ...e })), s[r];
}
function Is(t, e, n) {
  const s = Ds(e);
  return Ie.set(t, n), s.observe(t), () => {
    Ie.delete(t), s.unobserve(t);
  };
}
const ks = {
  some: 0,
  all: 1
};
class Ks extends Z {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const { viewport: e = {} } = this.node.getProps(), { root: n, margin: s, amount: r = "some", once: i } = e, o = {
      root: n ? n.current : void 0,
      rootMargin: s,
      threshold: typeof r == "number" ? r : ks[r]
    }, u = (a) => {
      const { isIntersecting: l } = a;
      if (this.isInView === l || (this.isInView = l, i && !l && this.hasEnteredView))
        return;
      l && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", l);
      const { onViewportEnter: c, onViewportLeave: h } = this.node.getProps(), d = l ? c : h;
      d && d(a);
    };
    return Is(this.node.current, o, u);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: e, prevProps: n } = this.node;
    ["amount", "margin", "root"].some(Es(e, n)) && this.startObserver();
  }
  unmount() {
  }
}
function Es({ viewport: t = {} }, { viewport: e = {} } = {}) {
  return (n) => t[n] !== e[n];
}
const Ns = {
  inView: {
    Feature: Ks
  },
  tap: {
    Feature: Fs
  },
  focus: {
    Feature: Ms
  },
  hover: {
    Feature: Cs
  }
};
function Yt(t, e) {
  if (!Array.isArray(e))
    return !1;
  const n = e.length;
  if (n !== t.length)
    return !1;
  for (let s = 0; s < n; s++)
    if (e[s] !== t[s])
      return !1;
  return !0;
}
function Te(t, e, n) {
  const s = t.getProps();
  return $t(s, e, n !== void 0 ? n : s.custom, t);
}
const E = (t) => t * 1e3, N = (t) => t / 1e3, Ls = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, Bs = (t) => ({
  type: "spring",
  stiffness: 550,
  damping: t === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), _s = {
  type: "keyframes",
  duration: 0.8
}, Ws = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, $s = (t, { keyframes: e }) => e.length > 2 ? _s : L.has(t) ? t.startsWith("scale") ? Bs(e[1]) : Ls : Ws;
function Gs({ when: t, delay: e, delayChildren: n, staggerChildren: s, staggerDirection: r, repeat: i, repeatType: o, repeatDelay: u, from: a, elapsed: l, ...c }) {
  return !!Object.keys(c).length;
}
function Xt(t, e) {
  return t[e] || t.default || t;
}
const Us = (t) => t !== null;
function Ve(t, { repeat: e, repeatType: n = "loop" }, s) {
  const r = t.filter(Us), i = e && n !== "loop" && e % 2 === 1 ? 0 : r.length - 1;
  return !i || s === void 0 ? r[i] : s;
}
let de;
function js() {
  de = void 0;
}
const z = {
  now: () => (de === void 0 && z.set(pe.isProcessing || Un.useManualTiming ? pe.timestamp : performance.now()), de),
  set: (t) => {
    de = t, queueMicrotask(js);
  }
}, Zt = (t) => /^0[^.\s]+$/u.test(t);
function zs(t) {
  return typeof t == "number" ? t === 0 : t !== null ? t === "none" || t === "0" || Zt(t) : !0;
}
const Jt = (t) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(t), Hs = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
);
function qs(t) {
  const e = Hs.exec(t);
  if (!e)
    return [,];
  const [, n, s, r] = e;
  return [`--${n ?? s}`, r];
}
const Ys = 4;
function Qt(t, e, n = 1) {
  H(n <= Ys, `Max CSS variable fallback depth detected in property "${t}". This may indicate a circular fallback dependency.`);
  const [s, r] = qs(t);
  if (!s)
    return;
  const i = window.getComputedStyle(e).getPropertyValue(s);
  if (i) {
    const o = i.trim();
    return Jt(o) ? parseFloat(o) : o;
  }
  return ze(r) ? Qt(r, e, n + 1) : r;
}
const Xs = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  "x",
  "y",
  "translateX",
  "translateY"
]), dt = (t) => t === X || t === p, ft = (t, e) => parseFloat(t.split(", ")[e]), pt = (t, e) => (n, { transform: s }) => {
  if (s === "none" || !s)
    return 0;
  const r = s.match(/^matrix3d\((.+)\)$/u);
  if (r)
    return ft(r[1], e);
  {
    const i = s.match(/^matrix\((.+)\)$/u);
    return i ? ft(i[1], t) : 0;
  }
}, Zs = /* @__PURE__ */ new Set(["x", "y", "z"]), Js = ie.filter((t) => !Zs.has(t));
function Qs(t) {
  const e = [];
  return Js.forEach((n) => {
    const s = t.getValue(n);
    s !== void 0 && (e.push([n, s.get()]), s.set(n.startsWith("scale") ? 1 : 0));
  }), e;
}
const Y = {
  // Dimensions
  width: ({ x: t }, { paddingLeft: e = "0", paddingRight: n = "0" }) => t.max - t.min - parseFloat(e) - parseFloat(n),
  height: ({ y: t }, { paddingTop: e = "0", paddingBottom: n = "0" }) => t.max - t.min - parseFloat(e) - parseFloat(n),
  top: (t, { top: e }) => parseFloat(e),
  left: (t, { left: e }) => parseFloat(e),
  bottom: ({ y: t }, { top: e }) => parseFloat(e) + (t.max - t.min),
  right: ({ x: t }, { left: e }) => parseFloat(e) + (t.max - t.min),
  // Transform
  x: pt(4, 13),
  y: pt(5, 14)
};
Y.translateX = Y.x;
Y.translateY = Y.y;
const en = (t) => (e) => e.test(t), er = {
  test: (t) => t === "auto",
  parse: (t) => t
}, tn = [X, p, j, k, us, ls, er], mt = (t) => tn.find(en(t)), $ = /* @__PURE__ */ new Set();
let ke = !1, Ke = !1;
function nn() {
  if (Ke) {
    const t = Array.from($).filter((s) => s.needsMeasurement), e = new Set(t.map((s) => s.element)), n = /* @__PURE__ */ new Map();
    e.forEach((s) => {
      const r = Qs(s);
      r.length && (n.set(s, r), s.render());
    }), t.forEach((s) => s.measureInitialState()), e.forEach((s) => {
      s.render();
      const r = n.get(s);
      r && r.forEach(([i, o]) => {
        var u;
        (u = s.getValue(i)) === null || u === void 0 || u.set(o);
      });
    }), t.forEach((s) => s.measureEndState()), t.forEach((s) => {
      s.suspendedScrollY !== void 0 && window.scrollTo(0, s.suspendedScrollY);
    });
  }
  Ke = !1, ke = !1, $.forEach((t) => t.complete()), $.clear();
}
function sn() {
  $.forEach((t) => {
    t.readKeyframes(), t.needsMeasurement && (Ke = !0);
  });
}
function tr() {
  sn(), nn();
}
class qe {
  constructor(e, n, s, r, i, o = !1) {
    this.isComplete = !1, this.isAsync = !1, this.needsMeasurement = !1, this.isScheduled = !1, this.unresolvedKeyframes = [...e], this.onComplete = n, this.name = s, this.motionValue = r, this.element = i, this.isAsync = o;
  }
  scheduleResolve() {
    this.isScheduled = !0, this.isAsync ? ($.add(this), ke || (ke = !0, P.read(sn), P.resolveKeyframes(nn))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const { unresolvedKeyframes: e, name: n, element: s, motionValue: r } = this;
    for (let i = 0; i < e.length; i++)
      if (e[i] === null)
        if (i === 0) {
          const o = r == null ? void 0 : r.get(), u = e[e.length - 1];
          if (o !== void 0)
            e[0] = o;
          else if (s && n) {
            const a = s.readValue(n, u);
            a != null && (e[0] = a);
          }
          e[0] === void 0 && (e[0] = u), r && o === void 0 && r.set(e[0]);
        } else
          e[i] = e[i - 1];
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete() {
    this.isComplete = !0, this.onComplete(this.unresolvedKeyframes, this.finalKeyframe), $.delete(this);
  }
  cancel() {
    this.isComplete || (this.isScheduled = !1, $.delete(this));
  }
  resume() {
    this.isComplete || this.scheduleResolve();
  }
}
const Ye = (t, e) => (n) => !!(oe(n) && os.test(n) && n.startsWith(t) || e && !as(n) && Object.prototype.hasOwnProperty.call(n, e)), rn = (t, e, n) => (s) => {
  if (!oe(s))
    return s;
  const [r, i, o, u] = s.match(He);
  return {
    [t]: parseFloat(r),
    [e]: parseFloat(i),
    [n]: parseFloat(o),
    alpha: u !== void 0 ? parseFloat(u) : 1
  };
}, nr = (t) => q(0, 255, t), Ce = {
  ...X,
  transform: (t) => Math.round(nr(t))
}, W = {
  test: Ye("rgb", "red"),
  parse: rn("red", "green", "blue"),
  transform: ({ red: t, green: e, blue: n, alpha: s = 1 }) => "rgba(" + Ce.transform(t) + ", " + Ce.transform(e) + ", " + Ce.transform(n) + ", " + te(ee.transform(s)) + ")"
};
function sr(t) {
  let e = "", n = "", s = "", r = "";
  return t.length > 5 ? (e = t.substring(1, 3), n = t.substring(3, 5), s = t.substring(5, 7), r = t.substring(7, 9)) : (e = t.substring(1, 2), n = t.substring(2, 3), s = t.substring(3, 4), r = t.substring(4, 5), e += e, n += n, s += s, r += r), {
    red: parseInt(e, 16),
    green: parseInt(n, 16),
    blue: parseInt(s, 16),
    alpha: r ? parseInt(r, 16) / 255 : 1
  };
}
const Ee = {
  test: Ye("#"),
  parse: sr,
  transform: W.transform
}, U = {
  test: Ye("hsl", "hue"),
  parse: rn("hue", "saturation", "lightness"),
  transform: ({ hue: t, saturation: e, lightness: n, alpha: s = 1 }) => "hsla(" + Math.round(t) + ", " + j.transform(te(e)) + ", " + j.transform(te(n)) + ", " + te(ee.transform(s)) + ")"
}, A = {
  test: (t) => W.test(t) || Ee.test(t) || U.test(t),
  parse: (t) => W.test(t) ? W.parse(t) : U.test(t) ? U.parse(t) : Ee.parse(t),
  transform: (t) => oe(t) ? t : t.hasOwnProperty("red") ? W.transform(t) : U.transform(t)
};
function rr(t) {
  var e, n;
  return isNaN(t) && oe(t) && (((e = t.match(He)) === null || e === void 0 ? void 0 : e.length) || 0) + (((n = t.match(is)) === null || n === void 0 ? void 0 : n.length) || 0) > 0;
}
const on = "number", an = "color", ir = "var", or = "var(", gt = "${}", ar = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function se(t) {
  const e = t.toString(), n = [], s = {
    color: [],
    number: [],
    var: []
  }, r = [];
  let i = 0;
  const u = e.replace(ar, (a) => (A.test(a) ? (s.color.push(i), r.push(an), n.push(A.parse(a))) : a.startsWith(or) ? (s.var.push(i), r.push(ir), n.push(a)) : (s.number.push(i), r.push(on), n.push(parseFloat(a))), ++i, gt)).split(gt);
  return { values: n, split: u, indexes: s, types: r };
}
function ln(t) {
  return se(t).values;
}
function un(t) {
  const { split: e, types: n } = se(t), s = e.length;
  return (r) => {
    let i = "";
    for (let o = 0; o < s; o++)
      if (i += e[o], r[o] !== void 0) {
        const u = n[o];
        u === on ? i += te(r[o]) : u === an ? i += A.transform(r[o]) : i += r[o];
      }
    return i;
  };
}
const lr = (t) => typeof t == "number" ? 0 : t;
function ur(t) {
  const e = ln(t);
  return un(t)(e.map(lr));
}
const J = {
  test: rr,
  parse: ln,
  createTransformer: un,
  getAnimatableNone: ur
}, cr = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function hr(t) {
  const [e, n] = t.slice(0, -1).split("(");
  if (e === "drop-shadow")
    return t;
  const [s] = n.match(He) || [];
  if (!s)
    return t;
  const r = n.replace(s, "");
  let i = cr.has(e) ? 1 : 0;
  return s !== n && (i *= 100), e + "(" + i + r + ")";
}
const dr = /\b([a-z-]*)\(.*?\)/gu, Ne = {
  ...J,
  getAnimatableNone: (t) => {
    const e = t.match(dr);
    return e ? e.map(hr).join(" ") : t;
  }
}, fr = {
  ...Nt,
  // Color props
  color: A,
  backgroundColor: A,
  outlineColor: A,
  fill: A,
  stroke: A,
  // Border props
  borderColor: A,
  borderTopColor: A,
  borderRightColor: A,
  borderBottomColor: A,
  borderLeftColor: A,
  filter: Ne,
  WebkitFilter: Ne
}, Xe = (t) => fr[t];
function cn(t, e) {
  let n = Xe(t);
  return n !== Ne && (n = J), n.getAnimatableNone ? n.getAnimatableNone(e) : void 0;
}
const pr = /* @__PURE__ */ new Set(["auto", "none", "0"]);
function mr(t, e, n) {
  let s = 0, r;
  for (; s < t.length && !r; ) {
    const i = t[s];
    typeof i == "string" && !pr.has(i) && se(i).values.length && (r = t[s]), s++;
  }
  if (r && n)
    for (const i of e)
      t[i] = cn(n, r);
}
class hn extends qe {
  constructor(e, n, s, r) {
    super(e, n, s, r, r == null ? void 0 : r.owner, !0);
  }
  readKeyframes() {
    const { unresolvedKeyframes: e, element: n, name: s } = this;
    if (!n.current)
      return;
    super.readKeyframes();
    for (let a = 0; a < e.length; a++) {
      let l = e[a];
      if (typeof l == "string" && (l = l.trim(), ze(l))) {
        const c = Qt(l, n.current);
        c !== void 0 && (e[a] = c), a === e.length - 1 && (this.finalKeyframe = l);
      }
    }
    if (this.resolveNoneKeyframes(), !Xs.has(s) || e.length !== 2)
      return;
    const [r, i] = e, o = mt(r), u = mt(i);
    if (o !== u)
      if (dt(o) && dt(u))
        for (let a = 0; a < e.length; a++) {
          const l = e[a];
          typeof l == "string" && (e[a] = parseFloat(l));
        }
      else
        this.needsMeasurement = !0;
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: e, name: n } = this, s = [];
    for (let r = 0; r < e.length; r++)
      zs(e[r]) && s.push(r);
    s.length && mr(e, s, n);
  }
  measureInitialState() {
    const { element: e, unresolvedKeyframes: n, name: s } = this;
    if (!e.current)
      return;
    s === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = Y[s](e.measureViewportBox(), window.getComputedStyle(e.current)), n[0] = this.measuredOrigin;
    const r = n[n.length - 1];
    r !== void 0 && e.getValue(s, r).jump(r, !1);
  }
  measureEndState() {
    var e;
    const { element: n, name: s, unresolvedKeyframes: r } = this;
    if (!n.current)
      return;
    const i = n.getValue(s);
    i && i.jump(this.measuredOrigin, !1);
    const o = r.length - 1, u = r[o];
    r[o] = Y[s](n.measureViewportBox(), window.getComputedStyle(n.current)), u !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = u), !((e = this.removedTransforms) === null || e === void 0) && e.length && this.removedTransforms.forEach(([a, l]) => {
      n.getValue(a).set(l);
    }), this.resolveNoneKeyframes();
  }
}
function dn(t) {
  let e;
  return () => (e === void 0 && (e = t()), e);
}
const yt = (t, e) => e === "zIndex" ? !1 : !!(typeof t == "number" || Array.isArray(t) || typeof t == "string" && // It's animatable if we have a string
(J.test(t) || t === "0") && // And it contains numbers and/or colors
!t.startsWith("url("));
function gr(t) {
  const e = t[0];
  if (t.length === 1)
    return !0;
  for (let n = 0; n < t.length; n++)
    if (t[n] !== e)
      return !0;
}
function yr(t, e, n, s) {
  const r = t[0];
  if (r === null)
    return !1;
  if (e === "display" || e === "visibility")
    return !0;
  const i = t[t.length - 1], o = yt(r, e), u = yt(i, e);
  return re(o === u, `You are trying to animate ${e} from "${r}" to "${i}". ${r} is not an animatable value - to enable this animation set ${r} to a value animatable to ${i} via the \`style\` property.`), !o || !u ? !1 : gr(t) || n === "spring" && s;
}
class fn {
  constructor({ autoplay: e = !0, delay: n = 0, type: s = "keyframes", repeat: r = 0, repeatDelay: i = 0, repeatType: o = "loop", ...u }) {
    this.isStopped = !1, this.hasAttemptedResolve = !1, this.options = {
      autoplay: e,
      delay: n,
      type: s,
      repeat: r,
      repeatDelay: i,
      repeatType: o,
      ...u
    }, this.updateFinishedPromise();
  }
  /**
   * A getter for resolved data. If keyframes are not yet resolved, accessing
   * this.resolved will synchronously flush all pending keyframe resolvers.
   * This is a deoptimisation, but at its worst still batches read/writes.
   */
  get resolved() {
    return !this._resolved && !this.hasAttemptedResolve && tr(), this._resolved;
  }
  /**
   * A method to be called when the keyframes resolver completes. This method
   * will check if its possible to run the animation and, if not, skip it.
   * Otherwise, it will call initPlayback on the implementing class.
   */
  onKeyframesResolved(e, n) {
    this.hasAttemptedResolve = !0;
    const { name: s, type: r, velocity: i, delay: o, onComplete: u, onUpdate: a, isGenerator: l } = this.options;
    if (!l && !yr(e, s, r, i))
      if (o)
        this.options.duration = 0;
      else {
        a == null || a(Ve(e, this.options, n)), u == null || u(), this.resolveFinishedPromise();
        return;
      }
    const c = this.initPlayback(e, n);
    c !== !1 && (this._resolved = {
      keyframes: e,
      finalKeyframe: n,
      ...c
    }, this.onPostResolved());
  }
  onPostResolved() {
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(e, n) {
    return this.currentFinishedPromise.then(e, n);
  }
  updateFinishedPromise() {
    this.currentFinishedPromise = new Promise((e) => {
      this.resolveFinishedPromise = e;
    });
  }
}
function pn(t, e) {
  return e ? t * (1e3 / e) : 0;
}
const vr = 5;
function mn(t, e, n) {
  const s = Math.max(e - vr, 0);
  return pn(n - t(s), e - s);
}
const Me = 1e-3, br = 0.01, vt = 10, Tr = 0.05, Vr = 1;
function wr({ duration: t = 800, bounce: e = 0.25, velocity: n = 0, mass: s = 1 }) {
  let r, i;
  re(t <= E(vt), "Spring duration must be 10 seconds or less");
  let o = 1 - e;
  o = q(Tr, Vr, o), t = q(br, vt, N(t)), o < 1 ? (r = (l) => {
    const c = l * o, h = c * t, d = c - n, f = Le(l, o), m = Math.exp(-h);
    return Me - d / f * m;
  }, i = (l) => {
    const h = l * o * t, d = h * n + n, f = Math.pow(o, 2) * Math.pow(l, 2) * t, m = Math.exp(-h), b = Le(Math.pow(l, 2), o);
    return (-r(l) + Me > 0 ? -1 : 1) * ((d - f) * m) / b;
  }) : (r = (l) => {
    const c = Math.exp(-l * t), h = (l - n) * t + 1;
    return -Me + c * h;
  }, i = (l) => {
    const c = Math.exp(-l * t), h = (n - l) * (t * t);
    return c * h;
  });
  const u = 5 / t, a = Sr(r, i, u);
  if (t = E(t), isNaN(a))
    return {
      stiffness: 100,
      damping: 10,
      duration: t
    };
  {
    const l = Math.pow(a, 2) * s;
    return {
      stiffness: l,
      damping: o * 2 * Math.sqrt(s * l),
      duration: t
    };
  }
}
const xr = 12;
function Sr(t, e, n) {
  let s = n;
  for (let r = 1; r < xr; r++)
    s = s - t(s) / e(s);
  return s;
}
function Le(t, e) {
  return t * Math.sqrt(1 - e * e);
}
const Ar = ["duration", "bounce"], Pr = ["stiffness", "damping", "mass"];
function bt(t, e) {
  return e.some((n) => t[n] !== void 0);
}
function Cr(t) {
  let e = {
    velocity: 0,
    stiffness: 100,
    damping: 10,
    mass: 1,
    isResolvedFromDuration: !1,
    ...t
  };
  if (!bt(t, Pr) && bt(t, Ar)) {
    const n = wr(t);
    e = {
      ...e,
      ...n,
      mass: 1
    }, e.isResolvedFromDuration = !0;
  }
  return e;
}
function gn({ keyframes: t, restDelta: e, restSpeed: n, ...s }) {
  const r = t[0], i = t[t.length - 1], o = { done: !1, value: r }, { stiffness: u, damping: a, mass: l, duration: c, velocity: h, isResolvedFromDuration: d } = Cr({
    ...s,
    velocity: -N(s.velocity || 0)
  }), f = h || 0, m = a / (2 * Math.sqrt(u * l)), b = i - r, V = N(Math.sqrt(u / l)), g = Math.abs(b) < 5;
  n || (n = g ? 0.01 : 2), e || (e = g ? 5e-3 : 0.5);
  let y;
  if (m < 1) {
    const v = Le(V, m);
    y = (x) => {
      const w = Math.exp(-m * V * x);
      return i - w * ((f + m * V * b) / v * Math.sin(v * x) + b * Math.cos(v * x));
    };
  } else if (m === 1)
    y = (v) => i - Math.exp(-V * v) * (b + (f + V * b) * v);
  else {
    const v = V * Math.sqrt(m * m - 1);
    y = (x) => {
      const w = Math.exp(-m * V * x), S = Math.min(v * x, 300);
      return i - w * ((f + m * V * b) * Math.sinh(S) + v * b * Math.cosh(S)) / v;
    };
  }
  return {
    calculatedDuration: d && c || null,
    next: (v) => {
      const x = y(v);
      if (d)
        o.done = v >= c;
      else {
        let w = f;
        v !== 0 && (m < 1 ? w = mn(y, v, x) : w = 0);
        const S = Math.abs(w) <= n, I = Math.abs(i - x) <= e;
        o.done = S && I;
      }
      return o.value = o.done ? i : x, o;
    }
  };
}
function Tt({ keyframes: t, velocity: e = 0, power: n = 0.8, timeConstant: s = 325, bounceDamping: r = 10, bounceStiffness: i = 500, modifyTarget: o, min: u, max: a, restDelta: l = 0.5, restSpeed: c }) {
  const h = t[0], d = {
    done: !1,
    value: h
  }, f = (T) => u !== void 0 && T < u || a !== void 0 && T > a, m = (T) => u === void 0 ? a : a === void 0 || Math.abs(u - T) < Math.abs(a - T) ? u : a;
  let b = n * e;
  const V = h + b, g = o === void 0 ? V : o(V);
  g !== V && (b = g - h);
  const y = (T) => -b * Math.exp(-T / s), v = (T) => g + y(T), x = (T) => {
    const M = y(T), F = v(T);
    d.done = Math.abs(M) <= l, d.value = d.done ? g : F;
  };
  let w, S;
  const I = (T) => {
    f(d.value) && (w = T, S = gn({
      keyframes: [d.value, m(d.value)],
      velocity: mn(v, T, d.value),
      // TODO: This should be passing * 1000
      damping: r,
      stiffness: i,
      restDelta: l,
      restSpeed: c
    }));
  };
  return I(0), {
    calculatedDuration: null,
    next: (T) => {
      let M = !1;
      return !S && w === void 0 && (M = !0, x(T), I(T)), w !== void 0 && T >= w ? S.next(T - w) : (!M && x(T), d);
    }
  };
}
const yn = (t, e, n) => (((1 - 3 * n + 3 * e) * t + (3 * n - 6 * e)) * t + 3 * e) * t, Mr = 1e-7, Fr = 12;
function Rr(t, e, n, s, r) {
  let i, o, u = 0;
  do
    o = e + (n - e) / 2, i = yn(o, s, r) - t, i > 0 ? n = o : e = o;
  while (Math.abs(i) > Mr && ++u < Fr);
  return o;
}
function le(t, e, n, s) {
  if (t === e && n === s)
    return O;
  const r = (i) => Rr(i, 0, 1, t, n);
  return (i) => i === 0 || i === 1 ? i : yn(r(i), e, s);
}
const Or = le(0.42, 0, 1, 1), Dr = le(0, 0, 0.58, 1), vn = le(0.42, 0, 0.58, 1), Ir = (t) => Array.isArray(t) && typeof t[0] != "number", bn = (t) => (e) => e <= 0.5 ? t(2 * e) / 2 : (2 - t(2 * (1 - e))) / 2, Tn = (t) => (e) => 1 - t(1 - e), Ze = (t) => 1 - Math.sin(Math.acos(t)), kr = Tn(Ze), Kr = bn(Ze), Vn = le(0.33, 1.53, 0.69, 0.99), Je = Tn(Vn), Er = bn(Je), Nr = (t) => (t *= 2) < 1 ? 0.5 * Je(t) : 0.5 * (2 - Math.pow(2, -10 * (t - 1))), Vt = {
  linear: O,
  easeIn: Or,
  easeInOut: vn,
  easeOut: Dr,
  circIn: Ze,
  circInOut: Kr,
  circOut: kr,
  backIn: Je,
  backInOut: Er,
  backOut: Vn,
  anticipate: Nr
}, wt = (t) => {
  if (Array.isArray(t)) {
    H(t.length === 4, "Cubic bezier arrays must contain four numerical values.");
    const [e, n, s, r] = t;
    return le(e, n, s, r);
  } else if (typeof t == "string")
    return H(Vt[t] !== void 0, `Invalid easing type '${t}'`), Vt[t];
  return t;
}, wn = (t, e, n) => {
  const s = e - t;
  return s === 0 ? 1 : (n - t) / s;
}, we = (t, e, n) => t + (e - t) * n;
function Fe(t, e, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? t + (e - t) * 6 * n : n < 1 / 2 ? e : n < 2 / 3 ? t + (e - t) * (2 / 3 - n) * 6 : t;
}
function Lr({ hue: t, saturation: e, lightness: n, alpha: s }) {
  t /= 360, e /= 100, n /= 100;
  let r = 0, i = 0, o = 0;
  if (!e)
    r = i = o = n;
  else {
    const u = n < 0.5 ? n * (1 + e) : n + e - n * e, a = 2 * n - u;
    r = Fe(a, u, t + 1 / 3), i = Fe(a, u, t), o = Fe(a, u, t - 1 / 3);
  }
  return {
    red: Math.round(r * 255),
    green: Math.round(i * 255),
    blue: Math.round(o * 255),
    alpha: s
  };
}
function me(t, e) {
  return (n) => n > 0 ? e : t;
}
const Re = (t, e, n) => {
  const s = t * t, r = n * (e * e - s) + s;
  return r < 0 ? 0 : Math.sqrt(r);
}, Br = [Ee, W, U], _r = (t) => Br.find((e) => e.test(t));
function xt(t) {
  const e = _r(t);
  if (re(!!e, `'${t}' is not an animatable color. Use the equivalent color code instead.`), !e)
    return !1;
  let n = e.parse(t);
  return e === U && (n = Lr(n)), n;
}
const St = (t, e) => {
  const n = xt(t), s = xt(e);
  if (!n || !s)
    return me(t, e);
  const r = { ...n };
  return (i) => (r.red = Re(n.red, s.red, i), r.green = Re(n.green, s.green, i), r.blue = Re(n.blue, s.blue, i), r.alpha = we(n.alpha, s.alpha, i), W.transform(r));
}, Be = /* @__PURE__ */ new Set(["none", "hidden"]);
function Wr(t, e) {
  return Be.has(t) ? (n) => n <= 0 ? t : e : (n) => n >= 1 ? e : t;
}
function $r(t, e) {
  return (n) => we(t, e, n);
}
function Qe(t) {
  return typeof t == "number" ? $r : typeof t == "string" ? ze(t) ? me : A.test(t) ? St : jr : Array.isArray(t) ? xn : typeof t == "object" ? A.test(t) ? St : Gr : me;
}
function xn(t, e) {
  const n = [...t], s = n.length, r = t.map((i, o) => Qe(i)(i, e[o]));
  return (i) => {
    for (let o = 0; o < s; o++)
      n[o] = r[o](i);
    return n;
  };
}
function Gr(t, e) {
  const n = { ...t, ...e }, s = {};
  for (const r in n)
    t[r] !== void 0 && e[r] !== void 0 && (s[r] = Qe(t[r])(t[r], e[r]));
  return (r) => {
    for (const i in s)
      n[i] = s[i](r);
    return n;
  };
}
function Ur(t, e) {
  var n;
  const s = [], r = { color: 0, var: 0, number: 0 };
  for (let i = 0; i < e.values.length; i++) {
    const o = e.types[i], u = t.indexes[o][r[o]], a = (n = t.values[u]) !== null && n !== void 0 ? n : 0;
    s[i] = a, r[o]++;
  }
  return s;
}
const jr = (t, e) => {
  const n = J.createTransformer(e), s = se(t), r = se(e);
  return s.indexes.var.length === r.indexes.var.length && s.indexes.color.length === r.indexes.color.length && s.indexes.number.length >= r.indexes.number.length ? Be.has(t) && !r.values.length || Be.has(e) && !s.values.length ? Wr(t, e) : K(xn(Ur(s, r), r.values), n) : (re(!0, `Complex values '${t}' and '${e}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`), me(t, e));
};
function Sn(t, e, n) {
  return typeof t == "number" && typeof e == "number" && typeof n == "number" ? we(t, e, n) : Qe(t)(t, e);
}
function zr(t, e, n) {
  const s = [], r = n || Sn, i = t.length - 1;
  for (let o = 0; o < i; o++) {
    let u = r(t[o], t[o + 1]);
    if (e) {
      const a = Array.isArray(e) ? e[o] || O : e;
      u = K(a, u);
    }
    s.push(u);
  }
  return s;
}
function Hr(t, e, { clamp: n = !0, ease: s, mixer: r } = {}) {
  const i = t.length;
  if (H(i === e.length, "Both input and output ranges must be the same length"), i === 1)
    return () => e[0];
  if (i === 2 && t[0] === t[1])
    return () => e[1];
  t[0] > t[i - 1] && (t = [...t].reverse(), e = [...e].reverse());
  const o = zr(e, s, r), u = o.length, a = (l) => {
    let c = 0;
    if (u > 1)
      for (; c < t.length - 2 && !(l < t[c + 1]); c++)
        ;
    const h = wn(t[c], t[c + 1], l);
    return o[c](h);
  };
  return n ? (l) => a(q(t[0], t[i - 1], l)) : a;
}
function qr(t, e) {
  const n = t[t.length - 1];
  for (let s = 1; s <= e; s++) {
    const r = wn(0, e, s);
    t.push(we(n, 1, r));
  }
}
function Yr(t) {
  const e = [0];
  return qr(e, t.length - 1), e;
}
function Xr(t, e) {
  return t.map((n) => n * e);
}
function Zr(t, e) {
  return t.map(() => e || vn).splice(0, t.length - 1);
}
function ge({ duration: t = 300, keyframes: e, times: n, ease: s = "easeInOut" }) {
  const r = Ir(s) ? s.map(wt) : wt(s), i = {
    done: !1,
    value: e[0]
  }, o = Xr(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    n && n.length === e.length ? n : Yr(e),
    t
  ), u = Hr(o, e, {
    ease: Array.isArray(r) ? r : Zr(e, r)
  });
  return {
    calculatedDuration: t,
    next: (a) => (i.value = u(a), i.done = a >= t, i)
  };
}
const At = 2e4;
function Jr(t) {
  let e = 0;
  const n = 50;
  let s = t.next(e);
  for (; !s.done && e < At; )
    e += n, s = t.next(e);
  return e >= At ? 1 / 0 : e;
}
const Qr = (t) => {
  const e = ({ timestamp: n }) => t(n);
  return {
    start: () => P.update(e, !0),
    stop: () => fe(e),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => pe.isProcessing ? pe.timestamp : z.now()
  };
}, ei = {
  decay: Tt,
  inertia: Tt,
  tween: ge,
  keyframes: ge,
  spring: gn
}, ti = (t) => t / 100;
class et extends fn {
  constructor({ KeyframeResolver: e = qe, ...n }) {
    super(n), this.holdTime = null, this.startTime = null, this.cancelTime = null, this.currentTime = 0, this.playbackSpeed = 1, this.pendingPlayState = "running", this.state = "idle", this.stop = () => {
      if (this.resolver.cancel(), this.isStopped = !0, this.state === "idle")
        return;
      this.teardown();
      const { onStop: u } = this.options;
      u && u();
    };
    const { name: s, motionValue: r, keyframes: i } = this.options, o = (u, a) => this.onKeyframesResolved(u, a);
    s && r && r.owner ? this.resolver = r.owner.resolveKeyframes(i, o, s, r) : this.resolver = new e(i, o, s, r), this.resolver.scheduleResolve();
  }
  initPlayback(e) {
    const { type: n = "keyframes", repeat: s = 0, repeatDelay: r = 0, repeatType: i, velocity: o = 0 } = this.options, u = ei[n] || ge;
    let a, l;
    u !== ge && typeof e[0] != "number" && (process.env.NODE_ENV !== "production" && H(e.length === 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${e}`), a = K(ti, Sn(e[0], e[1])), e = [0, 100]);
    const c = u({ ...this.options, keyframes: e });
    i === "mirror" && (l = u({
      ...this.options,
      keyframes: [...e].reverse(),
      velocity: -o
    })), c.calculatedDuration === null && (c.calculatedDuration = Jr(c));
    const { calculatedDuration: h } = c, d = h + r, f = d * (s + 1) - r;
    return {
      generator: c,
      mirroredGenerator: l,
      mapPercentToKeyframes: a,
      calculatedDuration: h,
      resolvedDuration: d,
      totalDuration: f
    };
  }
  onPostResolved() {
    const { autoplay: e = !0 } = this.options;
    this.play(), this.pendingPlayState === "paused" || !e ? this.pause() : this.state = this.pendingPlayState;
  }
  tick(e, n = !1) {
    const { resolved: s } = this;
    if (!s) {
      const { keyframes: T } = this.options;
      return { done: !0, value: T[T.length - 1] };
    }
    const { finalKeyframe: r, generator: i, mirroredGenerator: o, mapPercentToKeyframes: u, keyframes: a, calculatedDuration: l, totalDuration: c, resolvedDuration: h } = s;
    if (this.startTime === null)
      return i.next(0);
    const { delay: d, repeat: f, repeatType: m, repeatDelay: b, onUpdate: V } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, e) : this.speed < 0 && (this.startTime = Math.min(e - c / this.speed, this.startTime)), n ? this.currentTime = e : this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = Math.round(e - this.startTime) * this.speed;
    const g = this.currentTime - d * (this.speed >= 0 ? 1 : -1), y = this.speed >= 0 ? g < 0 : g > c;
    this.currentTime = Math.max(g, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = c);
    let v = this.currentTime, x = i;
    if (f) {
      const T = Math.min(this.currentTime, c) / h;
      let M = Math.floor(T), F = T % 1;
      !F && T >= 1 && (F = 1), F === 1 && M--, M = Math.min(M, f + 1), !!(M % 2) && (m === "reverse" ? (F = 1 - F, b && (F -= b / h)) : m === "mirror" && (x = o)), v = q(0, 1, F) * h;
    }
    const w = y ? { done: !1, value: a[0] } : x.next(v);
    u && (w.value = u(w.value));
    let { done: S } = w;
    !y && l !== null && (S = this.speed >= 0 ? this.currentTime >= c : this.currentTime <= 0);
    const I = this.holdTime === null && (this.state === "finished" || this.state === "running" && S);
    return I && r !== void 0 && (w.value = Ve(a, this.options, r)), V && V(w.value), I && this.finish(), w;
  }
  get duration() {
    const { resolved: e } = this;
    return e ? N(e.calculatedDuration) : 0;
  }
  get time() {
    return N(this.currentTime);
  }
  set time(e) {
    e = E(e), this.currentTime = e, this.holdTime !== null || this.speed === 0 ? this.holdTime = e : this.driver && (this.startTime = this.driver.now() - e / this.speed);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(e) {
    const n = this.playbackSpeed !== e;
    this.playbackSpeed = e, n && (this.time = N(this.currentTime));
  }
  play() {
    if (this.resolver.isScheduled || this.resolver.resume(), !this._resolved) {
      this.pendingPlayState = "running";
      return;
    }
    if (this.isStopped)
      return;
    const { driver: e = Qr, onPlay: n } = this.options;
    this.driver || (this.driver = e((r) => this.tick(r))), n && n();
    const s = this.driver.now();
    this.holdTime !== null ? this.startTime = s - this.holdTime : (!this.startTime || this.state === "finished") && (this.startTime = s), this.state === "finished" && this.updateFinishedPromise(), this.cancelTime = this.startTime, this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    var e;
    if (!this._resolved) {
      this.pendingPlayState = "paused";
      return;
    }
    this.state = "paused", this.holdTime = (e = this.currentTime) !== null && e !== void 0 ? e : 0;
  }
  complete() {
    this.state !== "running" && this.play(), this.pendingPlayState = this.state = "finished", this.holdTime = null;
  }
  finish() {
    this.teardown(), this.state = "finished";
    const { onComplete: e } = this.options;
    e && e();
  }
  cancel() {
    this.cancelTime !== null && this.tick(this.cancelTime), this.teardown(), this.updateFinishedPromise();
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.resolveFinishedPromise(), this.updateFinishedPromise(), this.startTime = this.cancelTime = null, this.resolver.cancel();
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(e) {
    return this.startTime = 0, this.tick(e, !0);
  }
}
const An = (t) => Array.isArray(t) && typeof t[0] == "number";
function Pn(t) {
  return !!(!t || typeof t == "string" && t in tt || An(t) || Array.isArray(t) && t.every(Pn));
}
const Q = ([t, e, n, s]) => `cubic-bezier(${t}, ${e}, ${n}, ${s})`, tt = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: Q([0, 0.65, 0.55, 1]),
  circOut: Q([0.55, 0, 1, 0.45]),
  backIn: Q([0.31, 0.01, 0.66, -0.59]),
  backOut: Q([0.33, 1.53, 0.69, 0.99])
};
function ni(t) {
  return Cn(t) || tt.easeOut;
}
function Cn(t) {
  if (t)
    return An(t) ? Q(t) : Array.isArray(t) ? t.map(ni) : tt[t];
}
function si(t, e, n, { delay: s = 0, duration: r = 300, repeat: i = 0, repeatType: o = "loop", ease: u, times: a } = {}) {
  const l = { [e]: n };
  a && (l.offset = a);
  const c = Cn(u);
  return Array.isArray(c) && (l.easing = c), t.animate(l, {
    delay: s,
    duration: r,
    easing: Array.isArray(c) ? "linear" : c,
    fill: "both",
    iterations: i + 1,
    direction: o === "reverse" ? "alternate" : "normal"
  });
}
const ri = dn(() => Object.hasOwnProperty.call(Element.prototype, "animate")), ye = 10, ii = 2e4;
function oi(t) {
  return t.type === "spring" || !Pn(t.ease);
}
function ai(t, e) {
  const n = new et({
    ...e,
    keyframes: t,
    repeat: 0,
    delay: 0,
    isGenerator: !0
  });
  let s = { done: !1, value: t[0] };
  const r = [];
  let i = 0;
  for (; !s.done && i < ii; )
    s = n.sample(i), r.push(s.value), i += ye;
  return {
    times: void 0,
    keyframes: r,
    duration: i - ye,
    ease: "linear"
  };
}
class Pt extends fn {
  constructor(e) {
    super(e);
    const { name: n, motionValue: s, keyframes: r } = this.options;
    this.resolver = new hn(r, (i, o) => this.onKeyframesResolved(i, o), n, s), this.resolver.scheduleResolve();
  }
  initPlayback(e, n) {
    var s;
    let { duration: r = 300, times: i, ease: o, type: u, motionValue: a, name: l } = this.options;
    if (!(!((s = a.owner) === null || s === void 0) && s.current))
      return !1;
    if (oi(this.options)) {
      const { onComplete: h, onUpdate: d, motionValue: f, ...m } = this.options, b = ai(e, m);
      e = b.keyframes, e.length === 1 && (e[1] = e[0]), r = b.duration, i = b.times, o = b.ease, u = "keyframes";
    }
    const c = si(a.owner.current, l, e, { ...this.options, duration: r, times: i, ease: o });
    return c.startTime = z.now(), this.pendingTimeline ? (c.timeline = this.pendingTimeline, this.pendingTimeline = void 0) : c.onfinish = () => {
      const { onComplete: h } = this.options;
      a.set(Ve(e, this.options, n)), h && h(), this.cancel(), this.resolveFinishedPromise();
    }, {
      animation: c,
      duration: r,
      times: i,
      type: u,
      ease: o,
      keyframes: e
    };
  }
  get duration() {
    const { resolved: e } = this;
    if (!e)
      return 0;
    const { duration: n } = e;
    return N(n);
  }
  get time() {
    const { resolved: e } = this;
    if (!e)
      return 0;
    const { animation: n } = e;
    return N(n.currentTime || 0);
  }
  set time(e) {
    const { resolved: n } = this;
    if (!n)
      return;
    const { animation: s } = n;
    s.currentTime = E(e);
  }
  get speed() {
    const { resolved: e } = this;
    if (!e)
      return 1;
    const { animation: n } = e;
    return n.playbackRate;
  }
  set speed(e) {
    const { resolved: n } = this;
    if (!n)
      return;
    const { animation: s } = n;
    s.playbackRate = e;
  }
  get state() {
    const { resolved: e } = this;
    if (!e)
      return "idle";
    const { animation: n } = e;
    return n.playState;
  }
  /**
   * Replace the default DocumentTimeline with another AnimationTimeline.
   * Currently used for scroll animations.
   */
  attachTimeline(e) {
    if (!this._resolved)
      this.pendingTimeline = e;
    else {
      const { resolved: n } = this;
      if (!n)
        return O;
      const { animation: s } = n;
      s.timeline = e, s.onfinish = null;
    }
    return O;
  }
  play() {
    if (this.isStopped)
      return;
    const { resolved: e } = this;
    if (!e)
      return;
    const { animation: n } = e;
    n.playState === "finished" && this.updateFinishedPromise(), n.play();
  }
  pause() {
    const { resolved: e } = this;
    if (!e)
      return;
    const { animation: n } = e;
    n.pause();
  }
  stop() {
    if (this.resolver.cancel(), this.isStopped = !0, this.state === "idle")
      return;
    const { resolved: e } = this;
    if (!e)
      return;
    const { animation: n, keyframes: s, duration: r, type: i, ease: o, times: u } = e;
    if (n.playState === "idle" || n.playState === "finished")
      return;
    if (this.time) {
      const { motionValue: l, onUpdate: c, onComplete: h, ...d } = this.options, f = new et({
        ...d,
        keyframes: s,
        duration: r,
        type: i,
        ease: o,
        times: u,
        isGenerator: !0
      }), m = E(this.time);
      l.setWithVelocity(f.sample(m - ye).value, f.sample(m).value, ye);
    }
    const { onStop: a } = this.options;
    a && a(), this.cancel();
  }
  complete() {
    const { resolved: e } = this;
    e && e.animation.finish();
  }
  cancel() {
    const { resolved: e } = this;
    e && e.animation.cancel();
  }
  static supports(e) {
    const { motionValue: n, name: s, repeatDelay: r, repeatType: i, damping: o, type: u } = e;
    return ri() && s && Gt.has(s) && n && n.owner && n.owner.current instanceof HTMLElement && /**
     * If we're outputting values to onUpdate then we can't use WAAPI as there's
     * no way to read the value from WAAPI every frame.
     */
    !n.owner.getProps().onUpdate && !r && i !== "mirror" && o !== 0 && u !== "inertia";
  }
}
function li(t, e) {
  let n;
  const s = () => {
    const { currentTime: r } = e, o = (r === null ? 0 : r.value) / 100;
    n !== o && t(o), n = o;
  };
  return P.update(s, !0), () => fe(s);
}
const ui = dn(() => window.ScrollTimeline !== void 0);
class ci {
  constructor(e) {
    this.stop = () => this.runAll("stop"), this.animations = e.filter(Boolean);
  }
  then(e, n) {
    return Promise.all(this.animations).then(e).catch(n);
  }
  /**
   * TODO: Filter out cancelled or stopped animations before returning
   */
  getAll(e) {
    return this.animations[0][e];
  }
  setAll(e, n) {
    for (let s = 0; s < this.animations.length; s++)
      this.animations[s][e] = n;
  }
  attachTimeline(e) {
    const n = this.animations.map((s) => {
      if (ui() && s.attachTimeline)
        s.attachTimeline(e);
      else
        return s.pause(), li((r) => {
          s.time = s.duration * r;
        }, e);
    });
    return () => {
      n.forEach((s, r) => {
        s && s(), this.animations[r].stop();
      });
    };
  }
  get time() {
    return this.getAll("time");
  }
  set time(e) {
    this.setAll("time", e);
  }
  get speed() {
    return this.getAll("speed");
  }
  set speed(e) {
    this.setAll("speed", e);
  }
  get duration() {
    let e = 0;
    for (let n = 0; n < this.animations.length; n++)
      e = Math.max(e, this.animations[n].duration);
    return e;
  }
  runAll(e) {
    this.animations.forEach((n) => n[e]());
  }
  play() {
    this.runAll("play");
  }
  pause() {
    this.runAll("pause");
  }
  cancel() {
    this.runAll("cancel");
  }
  complete() {
    this.runAll("complete");
  }
}
const hi = (t, e, n, s = {}, r, i, o) => (u) => {
  const a = Xt(s, t) || {}, l = a.delay || s.delay || 0;
  let { elapsed: c = 0 } = s;
  c = c - E(l);
  let h = {
    keyframes: Array.isArray(n) ? n : [null, n],
    ease: "easeOut",
    velocity: e.getVelocity(),
    ...a,
    delay: -c,
    onUpdate: (f) => {
      e.set(f), a.onUpdate && a.onUpdate(f);
    },
    onComplete: () => {
      u(), a.onComplete && a.onComplete(), o && o();
    },
    onStop: o,
    name: t,
    motionValue: e,
    element: i ? void 0 : r
  };
  Gs(a) || (h = {
    ...h,
    ...$s(t, h)
  }), h.duration && (h.duration = E(h.duration)), h.repeatDelay && (h.repeatDelay = E(h.repeatDelay)), h.from !== void 0 && (h.keyframes[0] = h.from);
  let d = !1;
  if ((h.type === !1 || h.duration === 0 && !h.repeatDelay) && (h.duration = 0, h.delay === 0 && (d = !0)), d && !i && e.get() !== void 0) {
    const f = Ve(h.keyframes, a);
    if (f !== void 0)
      return P.update(() => {
        h.onUpdate(f), h.onComplete();
      }), new ci([]);
  }
  return !i && Pt.supports(h) ? new Pt(h) : new et(h);
};
class Mn {
  constructor() {
    this.subscriptions = [];
  }
  add(e) {
    return Ts(this.subscriptions, e), () => Ut(this.subscriptions, e);
  }
  notify(e, n, s) {
    const r = this.subscriptions.length;
    if (r)
      if (r === 1)
        this.subscriptions[0](e, n, s);
      else
        for (let i = 0; i < r; i++) {
          const o = this.subscriptions[i];
          o && o(e, n, s);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const Ct = /* @__PURE__ */ new Set();
function nt(t, e, n) {
  t || Ct.has(e) || (console.warn(e), Ct.add(e));
}
const Mt = 30, di = (t) => !isNaN(parseFloat(t));
class Fn {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   *
   * @internal
   */
  constructor(e, n = {}) {
    this.version = "11.3.17", this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (s, r = !0) => {
      const i = z.now();
      this.updatedAt !== i && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(s), this.current !== this.prev && this.events.change && this.events.change.notify(this.current), r && this.events.renderRequest && this.events.renderRequest.notify(this.current);
    }, this.hasAnimated = !1, this.setCurrent(e), this.owner = n.owner;
  }
  setCurrent(e) {
    this.current = e, this.updatedAt = z.now(), this.canTrackVelocity === null && e !== void 0 && (this.canTrackVelocity = di(this.current));
  }
  setPrevFrameValue(e = this.current) {
    this.prevFrameValue = e, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(e) {
    return process.env.NODE_ENV !== "production" && nt(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", e);
  }
  on(e, n) {
    this.events[e] || (this.events[e] = new Mn());
    const s = this.events[e].add(n);
    return e === "change" ? () => {
      s(), P.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : s;
  }
  clearListeners() {
    for (const e in this.events)
      this.events[e].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   *
   * @internal
   */
  attach(e, n) {
    this.passiveEffect = e, this.stopPassiveEffect = n;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(e, n = !0) {
    !n || !this.passiveEffect ? this.updateAndNotify(e, n) : this.passiveEffect(e, this.updateAndNotify);
  }
  setWithVelocity(e, n, s) {
    this.set(n), this.prev = void 0, this.prevFrameValue = e, this.prevUpdatedAt = this.updatedAt - s;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(e, n = !0) {
    this.updateAndNotify(e), this.prev = e, this.prevUpdatedAt = this.prevFrameValue = void 0, n && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const e = z.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || e - this.updatedAt > Mt)
      return 0;
    const n = Math.min(this.updatedAt - this.prevUpdatedAt, Mt);
    return pn(parseFloat(this.current) - parseFloat(this.prevFrameValue), n);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   *
   * @internal
   */
  start(e) {
    return this.stop(), new Promise((n) => {
      this.hasAnimated = !0, this.animation = e(n), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function ve(t, e) {
  return new Fn(t, e);
}
function fi(t, e, n) {
  t.hasValue(e) ? t.getValue(e).set(n) : t.addValue(e, ve(n));
}
function pi(t, e) {
  const n = Te(t, e);
  let { transitionEnd: s = {}, transition: r = {}, ...i } = n || {};
  i = { ...i, ...s };
  for (const o in i) {
    const u = vs(i[o]);
    fi(t, o, u);
  }
}
function mi(t) {
  return t.getProps()[Gn];
}
class gi extends Fn {
  constructor() {
    super(...arguments), this.output = [], this.counts = /* @__PURE__ */ new Map();
  }
  add(e) {
    const n = bs(e);
    if (!n)
      return;
    const s = this.counts.get(n) || 0;
    this.counts.set(n, s + 1), s === 0 && (this.output.push(n), this.update());
    let r = !1;
    return () => {
      if (r)
        return;
      r = !0;
      const i = this.counts.get(n) - 1;
      this.counts.set(n, i), i === 0 && (Ut(this.output, n), this.update());
    };
  }
  update() {
    this.set(this.output.length ? this.output.join(", ") : "auto");
  }
}
function yi(t) {
  return !!(R(t) && t.add);
}
function vi(t, e) {
  var n;
  if (!t.applyWillChange)
    return;
  let s = t.getValue("willChange");
  if (!s && !(!((n = t.props.style) === null || n === void 0) && n.willChange) && (s = new gi("auto"), t.addValue("willChange", s)), yi(s))
    return s.add(e);
}
function bi({ protectedKeys: t, needsAnimating: e }, n) {
  const s = t.hasOwnProperty(n) && e[n] !== !0;
  return e[n] = !1, s;
}
function Rn(t, e, { delay: n = 0, transitionOverride: s, type: r } = {}) {
  var i;
  let { transition: o = t.getDefaultTransition(), transitionEnd: u, ...a } = e;
  s && (o = s);
  const l = [], c = r && t.animationState && t.animationState.getState()[r];
  for (const h in a) {
    const d = t.getValue(h, (i = t.latestValues[h]) !== null && i !== void 0 ? i : null), f = a[h];
    if (f === void 0 || c && bi(c, h))
      continue;
    const m = {
      delay: n,
      elapsed: 0,
      ...Xt(o || {}, h)
    };
    let b = !1;
    if (window.HandoffAppearAnimations) {
      const g = mi(t);
      if (g) {
        const y = window.HandoffAppearAnimations(g, h, d, P);
        y !== null && (m.elapsed = y, b = !0);
      }
    }
    d.start(hi(h, d, f, t.shouldReduceMotion && L.has(h) ? { type: !1 } : m, t, b, vi(t, h)));
    const V = d.animation;
    V && l.push(V);
  }
  return u && Promise.all(l).then(() => {
    P.update(() => {
      u && pi(t, u);
    });
  }), l;
}
function _e(t, e, n = {}) {
  var s;
  const r = Te(t, e, n.type === "exit" ? (s = t.presenceContext) === null || s === void 0 ? void 0 : s.custom : void 0);
  let { transition: i = t.getDefaultTransition() || {} } = r || {};
  n.transitionOverride && (i = n.transitionOverride);
  const o = r ? () => Promise.all(Rn(t, r, n)) : () => Promise.resolve(), u = t.variantChildren && t.variantChildren.size ? (l = 0) => {
    const { delayChildren: c = 0, staggerChildren: h, staggerDirection: d } = i;
    return Ti(t, e, c + l, h, d, n);
  } : () => Promise.resolve(), { when: a } = i;
  if (a) {
    const [l, c] = a === "beforeChildren" ? [o, u] : [u, o];
    return l().then(() => c());
  } else
    return Promise.all([o(), u(n.delay)]);
}
function Ti(t, e, n = 0, s = 0, r = 1, i) {
  const o = [], u = (t.variantChildren.size - 1) * s, a = r === 1 ? (l = 0) => l * s : (l = 0) => u - l * s;
  return Array.from(t.variantChildren).sort(Vi).forEach((l, c) => {
    l.notify("AnimationStart", e), o.push(_e(l, e, {
      ...i,
      delay: n + a(c)
    }).then(() => l.notify("AnimationComplete", e)));
  }), Promise.all(o);
}
function Vi(t, e) {
  return t.sortNodePosition(e);
}
function wi(t, e, n = {}) {
  t.notify("AnimationStart", e);
  let s;
  if (Array.isArray(e)) {
    const r = e.map((i) => _e(t, i, n));
    s = Promise.all(r);
  } else if (typeof e == "string")
    s = _e(t, e, n);
  else {
    const r = typeof e == "function" ? Te(t, e, n.custom) : e;
    s = Promise.all(Rn(t, r, n));
  }
  return s.then(() => {
    P.postRender(() => {
      t.notify("AnimationComplete", e);
    });
  });
}
const xi = [...Ue].reverse(), Si = Ue.length;
function Ai(t) {
  return (e) => Promise.all(e.map(({ animation: n, options: s }) => wi(t, n, s)));
}
function Pi(t) {
  let e = Ai(t), n = Ft(), s = !0;
  const r = (a) => (l, c) => {
    var h;
    const d = Te(t, c, a === "exit" ? (h = t.presenceContext) === null || h === void 0 ? void 0 : h.custom : void 0);
    if (d) {
      const { transition: f, transitionEnd: m, ...b } = d;
      l = { ...l, ...b, ...m };
    }
    return l;
  };
  function i(a) {
    e = a(t);
  }
  function o(a) {
    const l = t.getProps(), c = t.getVariantContext(!0) || {}, h = [], d = /* @__PURE__ */ new Set();
    let f = {}, m = 1 / 0;
    for (let V = 0; V < Si; V++) {
      const g = xi[V], y = n[g], v = l[g] !== void 0 ? l[g] : c[g], x = $e(v), w = g === a ? y.isActive : null;
      w === !1 && (m = V);
      let S = v === c[g] && v !== l[g] && x;
      if (S && s && t.manuallyAnimateOnMount && (S = !1), y.protectedKeys = { ...f }, // If it isn't active and hasn't *just* been set as inactive
      !y.isActive && w === null || // If we didn't and don't have any defined prop for this animation type
      !v && !y.prevProp || // Or if the prop doesn't define an animation
      Ge(v) || typeof v == "boolean")
        continue;
      let T = Ci(y.prevProp, v) || // If we're making this variant active, we want to always make it active
      g === a && y.isActive && !S && x || // If we removed a higher-priority variant (i is in reverse order)
      V > m && x, M = !1;
      const F = Array.isArray(v) ? v : [v];
      let G = F.reduce(r(g), {});
      w === !1 && (G = {});
      const { prevResolvedValues: st = {} } = y, kn = {
        ...st,
        ...G
      }, rt = (C) => {
        T = !0, d.has(C) && (M = !0, d.delete(C)), y.needsAnimating[C] = !0;
        const D = t.getValue(C);
        D && (D.liveStyle = !1);
      };
      for (const C in kn) {
        const D = G[C], xe = st[C];
        if (f.hasOwnProperty(C))
          continue;
        let Se = !1;
        De(D) && De(xe) ? Se = !Yt(D, xe) : Se = D !== xe, Se ? D != null ? rt(C) : d.add(C) : D !== void 0 && d.has(C) ? rt(C) : y.protectedKeys[C] = !0;
      }
      y.prevProp = v, y.prevResolvedValues = G, y.isActive && (f = { ...f, ...G }), s && t.blockInitialAnimation && (T = !1), T && (!S || M) && h.push(...F.map((C) => ({
        animation: C,
        options: { type: g }
      })));
    }
    if (d.size) {
      const V = {};
      d.forEach((g) => {
        const y = t.getBaseTarget(g), v = t.getValue(g);
        v && (v.liveStyle = !0), V[g] = y ?? null;
      }), h.push({ animation: V });
    }
    let b = !!h.length;
    return s && (l.initial === !1 || l.initial === l.animate) && !t.manuallyAnimateOnMount && (b = !1), s = !1, b ? e(h) : Promise.resolve();
  }
  function u(a, l) {
    var c;
    if (n[a].isActive === l)
      return Promise.resolve();
    (c = t.variantChildren) === null || c === void 0 || c.forEach((d) => {
      var f;
      return (f = d.animationState) === null || f === void 0 ? void 0 : f.setActive(a, l);
    }), n[a].isActive = l;
    const h = o(a);
    for (const d in n)
      n[d].protectedKeys = {};
    return h;
  }
  return {
    animateChanges: o,
    setActive: u,
    setAnimateFunction: i,
    getState: () => n,
    reset: () => {
      n = Ft(), s = !0;
    }
  };
}
function Ci(t, e) {
  return typeof e == "string" ? e !== t : Array.isArray(e) ? !Yt(e, t) : !1;
}
function B(t = !1) {
  return {
    isActive: t,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function Ft() {
  return {
    animate: B(!0),
    whileInView: B(),
    whileHover: B(),
    whileTap: B(),
    whileDrag: B(),
    whileFocus: B(),
    exit: B()
  };
}
class Mi extends Z {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(e) {
    super(e), e.animationState || (e.animationState = Pi(e));
  }
  updateAnimationControlsSubscription() {
    const { animate: e } = this.node.getProps();
    Ge(e) && (this.unmountControls = e.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: e } = this.node.getProps(), { animate: n } = this.node.prevProps || {};
    e !== n && this.updateAnimationControlsSubscription();
  }
  unmount() {
    var e;
    this.node.animationState.reset(), (e = this.unmountControls) === null || e === void 0 || e.call(this);
  }
}
let Fi = 0;
class Ri extends Z {
  constructor() {
    super(...arguments), this.id = Fi++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: e, onExitComplete: n } = this.node.presenceContext, { isPresent: s } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || e === s)
      return;
    const r = this.node.animationState.setActive("exit", !e);
    n && !e && r.then(() => n(this.id));
  }
  mount() {
    const { register: e } = this.node.presenceContext || {};
    e && (this.unmount = e(this.id));
  }
  unmount() {
  }
}
const Oi = {
  animation: {
    Feature: Mi
  },
  exit: {
    Feature: Ri
  }
}, Rt = () => ({ min: 0, max: 0 }), On = () => ({
  x: Rt(),
  y: Rt()
});
function Di({ top: t, left: e, right: n, bottom: s }) {
  return {
    x: { min: e, max: n },
    y: { min: t, max: s }
  };
}
function Ii(t, e) {
  if (!e)
    return t;
  const n = e({ x: t.left, y: t.top }), s = e({ x: t.right, y: t.bottom });
  return {
    top: n.y,
    left: n.x,
    bottom: s.y,
    right: s.x
  };
}
function ki(t, e) {
  return Di(Ii(t.getBoundingClientRect(), e));
}
const We = { current: null }, Dn = { current: !1 };
function Ki() {
  if (Dn.current = !0, !!_n)
    if (window.matchMedia) {
      const t = window.matchMedia("(prefers-reduced-motion)"), e = () => We.current = t.matches;
      t.addListener(e), e();
    } else
      We.current = !1;
}
function Ei(t, e, n) {
  for (const s in e) {
    const r = e[s], i = n[s];
    if (R(r))
      t.addValue(s, r), process.env.NODE_ENV === "development" && nt(r.version === "11.3.17", `Attempting to mix Framer Motion versions ${r.version} with 11.3.17 may not work as expected.`);
    else if (R(i))
      t.addValue(s, ve(r, { owner: t }));
    else if (i !== r)
      if (t.hasValue(s)) {
        const o = t.getValue(s);
        o.liveStyle === !0 ? o.jump(r) : o.hasAnimated || o.set(r);
      } else {
        const o = t.getStaticValue(s);
        t.addValue(s, ve(o !== void 0 ? o : r, { owner: t }));
      }
  }
  for (const s in n)
    e[s] === void 0 && t.removeValue(s);
  return e;
}
const Ot = /* @__PURE__ */ new WeakMap(), Ni = [...tn, A, J], Li = (t) => Ni.find(en(t)), Dt = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
], Bi = je.length;
class _i {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(e, n, s) {
    return {};
  }
  constructor({ parent: e, props: n, presenceContext: s, reducedMotionConfig: r, blockInitialAnimation: i, visualState: o }, u = {}) {
    this.applyWillChange = !1, this.resolveKeyframes = (d, f, m, b) => new this.KeyframeResolver(d, f, m, b, this), this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.KeyframeResolver = qe, this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.isRenderScheduled = !1, this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.isRenderScheduled = !1, this.scheduleRender = () => {
      this.isRenderScheduled || (this.isRenderScheduled = !0, P.render(this.render, !1, !0));
    };
    const { latestValues: a, renderState: l } = o;
    this.latestValues = a, this.baseTarget = { ...a }, this.initialValues = n.initial ? { ...a } : {}, this.renderState = l, this.parent = e, this.props = n, this.presenceContext = s, this.depth = e ? e.depth + 1 : 0, this.reducedMotionConfig = r, this.options = u, this.blockInitialAnimation = !!i, this.isControllingVariants = kt(n), this.isVariantNode = qn(n), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(e && e.current);
    const { willChange: c, ...h } = this.scrapeMotionValuesFromProps(n, {}, this);
    for (const d in h) {
      const f = h[d];
      a[d] !== void 0 && R(f) && f.set(a[d], !1);
    }
  }
  mount(e) {
    this.current = e, Ot.set(e, this), this.projection && !this.projection.instance && this.projection.mount(e), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((n, s) => this.bindToMotionValue(s, n)), Dn.current || Ki(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : We.current, process.env.NODE_ENV !== "production" && nt(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected."), this.parent && this.parent.children.add(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    Ot.delete(this.current), this.projection && this.projection.unmount(), fe(this.notifyUpdate), fe(this.render), this.valueSubscriptions.forEach((e) => e()), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent && this.parent.children.delete(this);
    for (const e in this.events)
      this.events[e].clear();
    for (const e in this.features) {
      const n = this.features[e];
      n && (n.unmount(), n.isMounted = !1);
    }
    this.current = null;
  }
  bindToMotionValue(e, n) {
    const s = L.has(e), r = n.on("change", (o) => {
      this.latestValues[e] = o, this.props.onUpdate && P.preRender(this.notifyUpdate), s && this.projection && (this.projection.isTransformDirty = !0);
    }), i = n.on("renderRequest", this.scheduleRender);
    this.valueSubscriptions.set(e, () => {
      r(), i(), n.owner && n.stop();
    });
  }
  sortNodePosition(e) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== e.type ? 0 : this.sortInstanceNodePosition(this.current, e.current);
  }
  updateFeatures() {
    let e = "animation";
    for (e in ne) {
      const n = ne[e];
      if (!n)
        continue;
      const { isEnabled: s, Feature: r } = n;
      if (!this.features[e] && r && s(this.props) && (this.features[e] = new r(this)), this.features[e]) {
        const i = this.features[e];
        i.isMounted ? i.update() : (i.mount(), i.isMounted = !0);
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : On();
  }
  getStaticValue(e) {
    return this.latestValues[e];
  }
  setStaticValue(e, n) {
    this.latestValues[e] = n;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(e, n) {
    (e.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = e, this.prevPresenceContext = this.presenceContext, this.presenceContext = n;
    for (let s = 0; s < Dt.length; s++) {
      const r = Dt[s];
      this.propEventSubscriptions[r] && (this.propEventSubscriptions[r](), delete this.propEventSubscriptions[r]);
      const i = "on" + r, o = e[i];
      o && (this.propEventSubscriptions[r] = this.on(r, o));
    }
    this.prevMotionValues = Ei(this, this.scrapeMotionValuesFromProps(e, this.prevProps, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(e) {
    return this.props.variants ? this.props.variants[e] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  getVariantContext(e = !1) {
    if (e)
      return this.parent ? this.parent.getVariantContext() : void 0;
    if (!this.isControllingVariants) {
      const s = this.parent ? this.parent.getVariantContext() || {} : {};
      return this.props.initial !== void 0 && (s.initial = this.props.initial), s;
    }
    const n = {};
    for (let s = 0; s < Bi; s++) {
      const r = je[s], i = this.props[r];
      ($e(i) || i === !1) && (n[r] = i);
    }
    return n;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(e) {
    const n = this.getClosestVariantNode();
    if (n)
      return n.variantChildren && n.variantChildren.add(e), () => n.variantChildren.delete(e);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(e, n) {
    const s = this.values.get(e);
    n !== s && (s && this.removeValue(e), this.bindToMotionValue(e, n), this.values.set(e, n), this.latestValues[e] = n.get());
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(e) {
    this.values.delete(e);
    const n = this.valueSubscriptions.get(e);
    n && (n(), this.valueSubscriptions.delete(e)), delete this.latestValues[e], this.removeValueFromRenderState(e, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(e) {
    return this.values.has(e);
  }
  getValue(e, n) {
    if (this.props.values && this.props.values[e])
      return this.props.values[e];
    let s = this.values.get(e);
    return s === void 0 && n !== void 0 && (s = ve(n === null ? void 0 : n, { owner: this }), this.addValue(e, s)), s;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(e, n) {
    var s;
    let r = this.latestValues[e] !== void 0 || !this.current ? this.latestValues[e] : (s = this.getBaseTargetFromProps(this.props, e)) !== null && s !== void 0 ? s : this.readValueFromInstance(this.current, e, this.options);
    return r != null && (typeof r == "string" && (Jt(r) || Zt(r)) ? r = parseFloat(r) : !Li(r) && J.test(n) && (r = cn(e, n)), this.setBaseTarget(e, R(r) ? r.get() : r)), R(r) ? r.get() : r;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(e, n) {
    this.baseTarget[e] = n;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(e) {
    var n;
    const { initial: s } = this.props;
    let r;
    if (typeof s == "string" || typeof s == "object") {
      const o = $t(this.props, s, (n = this.presenceContext) === null || n === void 0 ? void 0 : n.custom);
      o && (r = o[e]);
    }
    if (s && r !== void 0)
      return r;
    const i = this.getBaseTargetFromProps(this.props, e);
    return i !== void 0 && !R(i) ? i : this.initialValues[e] !== void 0 && r === void 0 ? void 0 : this.baseTarget[e];
  }
  on(e, n) {
    return this.events[e] || (this.events[e] = new Mn()), this.events[e].add(n);
  }
  notify(e, ...n) {
    this.events[e] && this.events[e].notify(...n);
  }
}
class In extends _i {
  constructor() {
    super(...arguments), this.KeyframeResolver = hn;
  }
  sortInstanceNodePosition(e, n) {
    return e.compareDocumentPosition(n) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(e, n) {
    return e.style ? e.style[n] : void 0;
  }
  removeValueFromRenderState(e, { vars: n, style: s }) {
    delete n[e], delete s[e];
  }
}
function Wi(t) {
  return window.getComputedStyle(t);
}
class $i extends In {
  constructor() {
    super(...arguments), this.type = "html", this.applyWillChange = !0, this.renderInstance = Bt;
  }
  readValueFromInstance(e, n) {
    if (L.has(n)) {
      const s = Xe(n);
      return s && s.default || 0;
    } else {
      const s = Wi(e), r = (Et(n) ? s.getPropertyValue(n) : s[n]) || 0;
      return typeof r == "string" ? r.trim() : r;
    }
  }
  measureInstanceViewportBox(e, { transformPagePoint: n }) {
    return ki(e, n);
  }
  build(e, n, s) {
    Lt(e, n, s.transformTemplate);
  }
  scrapeMotionValuesFromProps(e, n, s) {
    return Wt(e, n, s);
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: e } = this.props;
    R(e) && (this.childSubscription = e.on("change", (n) => {
      this.current && (this.current.textContent = `${n}`);
    }));
  }
}
class Gi extends In {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = On;
  }
  getBaseTargetFromProps(e, n) {
    return e[n];
  }
  readValueFromInstance(e, n) {
    if (L.has(n)) {
      const s = Xe(n);
      return s && s.default || 0;
    }
    return n = _t.has(n) ? n : be(n), e.getAttribute(n);
  }
  scrapeMotionValuesFromProps(e, n, s) {
    return ys(e, n, s);
  }
  build(e, n, s) {
    ps(e, n, this.isSVGTag, s.transformTemplate);
  }
  renderInstance(e, n, s, r) {
    gs(e, n, s, r);
  }
  mount(e) {
    this.isSVGTag = ms(e.tagName), super.mount(e);
  }
}
const Ui = (t, e) => Xn(t) ? new Gi(e) : new $i(e, {
  allowProjection: t !== En
});
function ji({ children: t, features: e, strict: n = !1 }) {
  const [, s] = Nn(!Oe(e)), r = Ln(void 0);
  if (!Oe(e)) {
    const { renderer: i, ...o } = e;
    r.current = i, ot(o);
  }
  return Bn(() => {
    Oe(e) && e().then(({ renderer: i, ...o }) => {
      ot(o), r.current = i, s(!0);
    });
  }, []), It.jsx(Wn.Provider, { value: { renderer: r.current, strict: n }, children: t });
}
function Oe(t) {
  return typeof t == "function";
}
const zi = {
  renderer: Ui,
  ...Oi,
  ...Ns
}, Zi = ({ children: t }) => /* @__PURE__ */ It.jsx(ji, { features: zi, strict: !0, children: t });
export {
  Wn as L,
  Zi as M,
  _n as a,
  kt as b,
  Hn as c,
  $e as d,
  ne as e,
  P as f,
  R as g,
  Jn as h,
  H as i,
  Lt as j,
  ps as k,
  ot as l,
  ms as m,
  Xn as n,
  Gn as o,
  Yi as p,
  qn as q,
  Ge as r,
  $t as s,
  bs as t,
  Ts as u,
  ys as v,
  re as w,
  gs as x,
  Wt as y
};
//# sourceMappingURL=motion-jk0ivqSc.js.map
